import { ContentAppearanceType } from '@confluence/content-appearance';

export enum GraphQLTemplateContentAppearance {
	DEFAULT = 'DEFAULT',
	FULL_WIDTH = 'FULL_WIDTH',
}

type GraphQLTemplateContentAppearanceToContentAppearanceMap = {
	[key in GraphQLTemplateContentAppearance]: ContentAppearanceType;
};

const _graphQLTemplateContentAppearanceToAtlaskitMap: GraphQLTemplateContentAppearanceToContentAppearanceMap =
	{
		[GraphQLTemplateContentAppearance.DEFAULT]: ContentAppearanceType.DEFAULT,
		[GraphQLTemplateContentAppearance.FULL_WIDTH]: ContentAppearanceType.FULL_WIDTH,
	};

export const convertGraphQLTemplateContentAppearanceToContentAppearanceType = (
	templateContentAppearance: GraphQLTemplateContentAppearance,
): ContentAppearanceType =>
	_graphQLTemplateContentAppearanceToAtlaskitMap[templateContentAppearance] ||
	ContentAppearanceType.DEFAULT;
